<article class="message-card"
         [class.outbound]="message().direction === 'OUT'"
         [style.border-left-color]="avatarColor()">
  <header class="card-header">
    <span class="card-avatar"
          [style.background-color]="avatarColor()">{{ initials() }}</span>
    <div class="card-sender">
      <span class="card-sender-name">{{ senderName() }}</span>
      @if (message().email) {
      <span class="card-sender-email">{{ message().email }}</span>
      }
    </div>
    <span class="card-time">{{ message().date | date:'H:mm' }}</span>
  </header>

  <div class="card-body"
       [innerHTML]="message().content | markdownHtml"></div>

  @if (message().attachments && message().attachments.length > 0) {
  <section class="card-attachments">
    <div class="attachments-row">
      <div class="attachments-summary">
        <mat-icon class="attach-icon">attach_file</mat-icon>
        <span>{{ message().attachments.length }} {{ 'message.details.attachments' | translate }}</span>
      </div>

      @if (hasIcareControls()) {
      <div class="attachments-actions"
           (click)="$event.stopPropagation()">
        @if (selectedCount() > 0) {
        <span class="attachments-selected-count">
          {{ 'message.details.attachmentsRow.selectedCount' | translate:{ count: selectedCount() } }}
        </span>
        }
        <button type="button"
                class="link-button"
                (click)="selectAllToggle.emit(message())">
          {{ (allSelected() ? 'message.details.attachmentsRow.deselectAll' : 'message.details.attachmentsRow.selectAll') | translate }}
        </button>
        <button type="button"
                class="icare-button"
                [disabled]="selectedCount() === 0"
                (click)="sendToIcare.emit(message())">
          <mat-icon>open_in_new</mat-icon>
          <span>{{ 'message.details.attachmentsRow.sendToIcare' | translate }}</span>
        </button>
      </div>
      }
    </div>

    <div class="attachments-list">
      @for (attachment of message().attachments; track attachment.id ?? $index) {
      <div class="attachment-tile"
           [class.selected]="isSelected(attachment)"
           (click)="$event.stopPropagation()">
        @if (isBlocked(attachment)) {
        <span class="attachment-warning"
              [matTooltip]="'message.details.bulkSelection.caseStepInvalidTooltip' | translate"
              matTooltipPosition="above">
          <mat-icon>warning</mat-icon>
        </span>
        } @else if (isSelectable(attachment)) {
        <label class="attachment-selector"
               [attr.aria-label]="'message.details.bulkSelection.selectAttachment' | translate">
          <input type="checkbox"
                 [checked]="isSelected(attachment)"
                 (change)="toggleAttachment.emit(attachment)">
        </label>
        }

        <button type="button"
                class="attachment-open"
                (click)="openAttachment.emit(attachment)">
          <span class="attachment-icon"
                [style.background-color]="getAttachmentColor(attachment)">
            <mat-icon>{{ getAttachmentIcon(attachment) }}</mat-icon>
          </span>
          <span class="attachment-meta">
            <span class="attachment-name">{{ getAttachmentLabel(attachment) }}</span>
            @if (formatSize(attachment.size)) {
            <span class="attachment-size">{{ formatSize(attachment.size) }}</span>
            }
          </span>
        </button>
      </div>
      }
    </div>
  </section>
  }

  <footer class="card-actions">
    <div class="card-actions-left">
      <button type="button" class="action-btn action-btn--primary" (click)="reply.emit(message())">
        <mat-icon>reply</mat-icon>
        <span>{{ 'message.details.actionRow.reply' | translate }}</span>
      </button>
      <button type="button" class="action-btn" (click)="transfer.emit(message())">
        <mat-icon>forward</mat-icon>
        <span>{{ 'message.details.actionRow.transfer' | translate }}</span>
      </button>
    </div>

    <div class="card-actions-right">
      <span class="action-label">{{ 'message.details.actionRow.assigned' | translate }}</span>
      <app-assignee-picker [collaborators]="collaborators()"
                           [assignedId]="message().assignedCollaboratorId"
                           (assigneeChange)="onAssigneeChange($event)"></app-assignee-picker>
      <span class="action-label">{{ 'message.details.actionRow.status' | translate }}</span>
      <app-status-select [status]="message().status"
                         (statusChange)="onStatusChange($event)"></app-status-select>
    </div>
  </footer>
</article>
